import {
    getLedControllerDeviceStatusDetails, getLedControllerTypes, getAisleTypes,
    setLEDControllerDisableMonitoringData, updateLedControllerStatus, addLedController,
    setDefaultValues
} from "../network/LEDControllerOverviewNetworkAPI";

export const LEDControllerOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "LOAD_VIEW":
            getLedControllerDeviceStatusDetails(action.data.dispatcher)
            return state
        case "LOAD_AISLE_TYPES":
            getAisleTypes(action.data.dispatcher)
            return state
        case "RECEIVE_AISLE_TYPES":
            return {...state, ...action.data}
        case "LOAD_LED_CONTROLLER_TYPES":
            getLedControllerTypes(action.data.dispatcher)
            return state
        case "RECEIVE_LED_CONTROLLER_TYPES":
            return {...state, ...action.data}
        case "SET_LOADING":
            return {...state, ...action.data}
        case "SET_DEFAULT_VALUES":
            setDefaultValues(action.data.dispatcher, action.data.defaultValues, action.data.showCustomAlert)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setLEDControllerDisableMonitoringData(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        case "ADD_NEW_DEVICE":
            addLedController(action.data.dispatcher, action.data.model, action.data.showCustomAlert)
            return state
        case "DELETE_DEVICE_DATA":
            updateLedControllerStatus(action.data.dispatcher, action.data.mac, action.data.assetType, "DEPRECATED",
                action.data.showCustomAlert)
            return state
        case "SET_MONITORING_STATUS_LOADER":
            return {...state, monitoringStatusLoadingDevices: {...state.monitoringStatusLoadingDevices, [action.data.mac]: action.data.monitoringStatusLoading} }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/reducer/LEDControllerOverviewReducer.js